import { Component, OnInit, Input } from '@angular/core';
import { RxComponent } from 'app/core/components/common/rx.component';
import { VimeoModalService, VimeoModalInfo } from 'app/shared/components/vimeo-modal/vimeo-modal.service';
import { Router } from '@angular/router';
import { Scheduler } from 'rxjs';

@Component({
  selector: 'itpx-guidance',
  templateUrl: './guidance.component.html',
  styleUrls: ['./guidance.component.css']
})
export class GuidanceComponent extends RxComponent {

  @Input() config: string;

  constructor(
    private vimeoService: VimeoModalService,
    private router: Router,
  ) { super(); }

  ngOnInit() {
  }

  private onNeedHelpClick() {
    if (!this.config) {
      console.error('Component config not defined');
      return;
    }
    let parts = this.config.split(':');
    if (parts[0] === 'navigate') {
      if (2 > parts.length) {
        console.error('Config requires 2 parts seperated by colon (:)');
        return;
      }
      this.router.navigate([parts[1]]);
    } else if (parts[0] === 'vimeo') {
      if (5 > parts.length) {
        console.error('Config requires 5 parts seperated by colon (:)');
        return;
      }
      this.vimeoService.open(new VimeoModalInfo(parts[1], parts[2], parts[3], parts[4]), true).neverError()
        // Delay subscribe to modal open because of 'checked after' error...
        .subscribeOn(Scheduler.queue, 1000)
        .bindToLifecycle(this)
        .subscribe();
    }
    // this.router.navigate(['/support/guides']);
  }
}



// WEBPACK FOOTER //
// ./src/app/solar/common/guidance/guidance.component.ts